import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiResponse } from "models";
import { enumAction } from "./enumSlice";
import { EnumPayload } from "api/enums";
import enumApi from "api/enums";

function* getEnumList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      enumApi.getEnumList,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      yield put(enumAction.getEnumSuccess(data));
    } else {
      toast.error(data.message || "Failed to fetch enums ❌");
      yield put(enumAction.getEnumFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      success: false,
      message: "Something went wrong ❌",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(enumAction.getEnumFailed(errorData));
  }
}

function* getEnumType(action: PayloadAction<EnumPayload>) {
  try {
    const response: ApiResponse = yield call(
      enumApi.getEnumType,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      yield put(enumAction.getEnumTypeSuccess(data));
    } else {
      toast.error(data.message || "Failed to fetch enum type ❌");
      yield put(enumAction.getEnumTypeFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      success: false,
      message: "Something went wrong ❌",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(enumAction.getEnumTypeFailed(errorData));
  }
}

function* saveEnumSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      enumApi.addOrUpdateEnum,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      toast.success(data.message || "Enum saved successfully ✅");
      yield put(enumAction.saveEnumSuccess(data));
    } else {
      toast.error(data.message || "Failed to save enum ❌");
      yield put(enumAction.saveEnumFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      success: false,
      message: "Something went wrong ❌",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(enumAction.saveEnumFailed(errorData));
  }
}

function* deleteEnumKeySaga(action: any) {
  try {
    const response: ApiResponse = yield call(
      enumApi.deleteEnumKey,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message || "Enum key deleted successfully ✅");
      yield put(enumAction.deleteEnumKeySuccess(data));
    } else {
      toast.error(response.message || "Failed to delete enum key ❌");
      yield put(enumAction.deleteEnumKeyFailure(response));
    }
  } catch (error: any) {
    toast.error(error.response?.data?.message || "Something went wrong ❌");
    yield put(
      enumAction.deleteEnumKeyFailure(error.response?.data || error.message)
    );
  }
}

export function* deleteEnumTypeSaga(action: any) {
  try {
    const response: ApiResponse = yield call(
      enumApi.deleteEnumType,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      toast.success(data.message || "Enum type deleted successfully ✅");
      yield put(enumAction.deleteEnumTypeSuccess(data));
    } else {
      toast.error(data.message || "Failed to delete enum type ❌");
      yield put(enumAction.deleteEnumTypeFailure(data));
    }
  } catch (error: any) {
    toast.error(error.response?.data?.message || "Something went wrong ❌");
    yield put(
      enumAction.deleteEnumTypeFailure(error.response?.data || error.message)
    );
  }
}
export default function* enumSaga() {
  yield takeLatest(enumAction.getEnum.type, getEnumList);
  yield takeLatest(enumAction.getEnumType.type, getEnumType);
  yield takeLatest(enumAction.saveEnum.type, saveEnumSaga);
  yield takeLatest(enumAction.deleteEnumKeyRequest.type, deleteEnumKeySaga);
  yield takeLatest(enumAction.deleteEnumTypeRequest.type, deleteEnumTypeSaga);
}
